module.exports = __webpack_public_path__ + "img/bg_multiple_chips.e7f78d27.png";